import { render } from "./Rating.vue?vue&type=template&id=0aa6a367"
import script from "./Rating.vue?vue&type=script&lang=js"
export * from "./Rating.vue?vue&type=script&lang=js"

import "./Rating.vue?vue&type=style&index=0&id=0aa6a367&lang=css"
script.render = render

export default script